// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2505) return "static/chunks/164f4fb6-a54ec72f6c0a2ad7.js";
	if (chunkId === 6065) return "static/chunks/6065-fbdc558baaf8c8b3.js";
	if (chunkId === 1425) return "static/chunks/2170a4aa-4c28bd5ca0271c93.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"124":"b68a48490a8b6d26","1838":"4fef8378c2c680fe","6919":"aa06879c0773525b","7337":"998f30d8f70dc1a8","8445":"efe0d145509f69ab"}[chunkId] + ".js";
};